/**
 * DigitalEvent Mutations
 */
import Vue from "vue";

export default {
  /**
   * Save user invites to the store
   * @param state {Object}
   * @param invites {Object}
   */
  setInvites(state, { sentInvites, receivedInvites }) {
    state.sentInvites = sentInvites;
    state.receivedInvites = receivedInvites;

    let sentInvitesUsersMap = {};
    sentInvites.forEach(invite => {
      if (!sentInvitesUsersMap[invite.inviteType]) {
        sentInvitesUsersMap[invite.inviteType] = {};
      }
      sentInvitesUsersMap[invite.inviteType][invite.inviteeUUID] = invite;
    });

    state.sentInvitesUsersMap = sentInvitesUsersMap;
  },

  /**
   * Add sent invite in the store
   * @param state {Object}
   * @param invite {Object}
   */
  addSentInvite(state, invite) {
    state.sentInvites.push(invite);

    if (!state.sentInvitesUsersMap[invite.inviteType]) {
      Vue.set(state.sentInvitesUsersMap, invite.inviteType, {});
    }

    Vue.set(state.sentInvitesUsersMap[invite.inviteType], invite.inviteeUUID, invite);
  },

  /**
   * Update sent invite in the store
   * @param state {Object}
   * @param invite {Object}
   */
  updateSentInvite(state, invite) {
    let inviteIndex = state.sentInvites.findIndex(i => i.uuid === invite.uuid);
    Vue.set(state.sentInvites, inviteIndex, invite);
  },

  /**
   * Delete sent invite in the state
   * @param state {Object}
   * @param invite {Object}
   */
  deleteSentInvite(state, invite) {
    let inviteIndex = state.sentInvites.findIndex(sentInvite => {
      return sentInvite.inviteType === invite.inviteType && sentInvite.inviteeUUID === invite.inviteeUUID;
    });
    state.sentInvites.splice(inviteIndex, 1);

    let sentInvitesUsersMap = {};
    state.sentInvites.forEach(invite => {
      if (!sentInvitesUsersMap[invite.inviteType]) {
        sentInvitesUsersMap[invite.inviteType] = {};
      }
      sentInvitesUsersMap[invite.inviteType][invite.inviteeUUID] = invite;
    });

    state.sentInvitesUsersMap = sentInvitesUsersMap;
  },

  /**
   * Add an invite in the state
   * @param state {Object}
   * @param invite {Object}
   */
  addReceivedInvite(state, invite) {
    state.receivedInvites.push(invite);
  },

  /**
   * Remove a table change invite from the state (after accepting or declining)
   * @param state {Object}
   * @param invite {Object} - invite
   */
  deleteReceivedInvite(state, invite) {
    let inviteIndex = state.receivedInvites.findIndex(receivedInvite => receivedInvite.uuid === invite.uuid);
    state.receivedInvites.splice(inviteIndex, 1);
  },

  /**
   * Save displaying invite to the store
   * @param state {Object}
   * @param invite {Object}
   * @param notification {Object}
   * @param timeoutId {Integer}
   */
  addDisplayingInvite(state, { invite, notification, timeoutId }) {
    state.displayingReceivedInvites[invite.uuid] = {
      notification: notification,
      timeoutId: timeoutId
    };
  },

  /**
   * Delete displaying Invite
   * @param state {Object}
   * @param invite {Object}
   */
  deleteDisplayingInvite(state, invite) {
    if (state.displayingReceivedInvites[invite.uuid]) {
      let { notification, timeoutId } = state.displayingReceivedInvites[invite.uuid];

      notification.close();

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    }
  },

  /**
   * Set creation status of videoCall invite
   * @param state {Object}
   * @param status {String}
   */
  setVideoCallInviteCreationStatus(state, status) {
    state.videoCallInviteCreationStatus = status;
  }
};
